module.exports = __webpack_public_path__ + "img/DJ.61579180.png";